import { render, staticRenderFns } from "./GoalInfo.vue?vue&type=template&id=76816e76&scoped=true&"
import script from "./GoalInfo.vue?vue&type=script&lang=ts&"
export * from "./GoalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GoalInfo.vue?vue&type=style&index=0&id=76816e76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76816e76",
  null
  
)

export default component.exports